import React, { useState } from 'react';
import { Button } from 'reactstrap';
import Select, { OptionsType } from 'react-select';

const FilterDropdown:React.FC<{
  filterName:string;
  options: OptionsType<{ label: string; value: string; }>;
  value: Array<string>;
  setValue: (val: Array<string>) => void;
  selectPlaceholder?: string;
}> = ({filterName, options, value, setValue, selectPlaceholder}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  return (
    <div className="filter-dd-container">
      <Button
        className={(value.length > 0) ? 'btn-set-opacity' : ''}
        type="button"
        onClick={() => {setShowDropdown(!showDropdown)}}>
          <span><img src="/icons/speakers-ico.svg" alt="" />{filterName}</span>
          <img src="/icons/dropdown-add-ico.svg" alt="" />
        </Button>
      <div className={`f-dropdown ${showDropdown ? 'show-f-dropdown' : ''}`}>
        <Select onChange={obj => {
          if(!obj) { setValue([]); return; }
          if(Array.isArray(obj)) {
            setValue(obj.map((e: any) => e.value))
          }
        }}
        placeholder={selectPlaceholder}
        isClearable={false}
        classNamePrefix="react-select"
        className="react-select-container"
        menuIsOpen
        isMulti
        options={options} />
      </div>
    </div>
  )
}

export default FilterDropdown;